import React, { useEffect, useRef } from 'react';
import logo from '../../Assets/ASI LOGO 2 - WHITE.png';
import '../Header/header.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { RiFileExcel2Fill } from "react-icons/ri";


function Header() {
  const navbarRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    const currentPath = window.location.pathname;

    const pathToPageMap = {
      '/sales-enq-list': 'sales-enq-list',
      '/customer': 'customer',
      '/estimation': 'estimation',
      '/sales-order': 'sales-order',
      '/management': 'management'
    };

    const pageKey = pathToPageMap[currentPath];

    if (pageKey) {
      localStorage.removeItem(`${pageKey}-isLoggedIn`);
      localStorage.removeItem(`${pageKey}-username`);
      navigate(`/login?page=${pageKey}`);
      window.location.reload();
    } else {
      navigate('/login');
    }
  };

  useEffect(() => {
    const hamburger = document.querySelector('.hamburger');
    const navMenu = document.querySelector('.nav-menu');
    const navLinks = document.querySelectorAll('.nav-link');
    const navbar = navbarRef.current;
    const sections = document.querySelectorAll('section');

    const toggleMenu = () => {
      hamburger.classList.toggle('active');
      navMenu.classList.toggle('active');
    };
    hamburger.addEventListener('click', toggleMenu);

    navLinks.forEach(link => {
      link.addEventListener('click', () => {
        hamburger.classList.remove('active');
        navMenu.classList.remove('active');
        document.body.classList.remove('no-scroll');
      });
    });

    const handleNavbarScroll = () => {
      if (window.scrollY > 100) {
        navbar.classList.add('scrolled');
      } else {
        navbar.classList.remove('scrolled');
      }
    };
    window.addEventListener('scroll', handleNavbarScroll);

    const highlightSection = () => {
      let current = '';
      const scrollPosition = window.pageYOffset + navbar.offsetHeight;

      sections.forEach(section => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.clientHeight;
        if (
          scrollPosition >= sectionTop &&
          scrollPosition < sectionTop + sectionHeight
        ) {
          current = section.getAttribute('id');
        }
      });

      navLinks.forEach(link => {
        link.classList.remove('active');
        if (link.getAttribute('href').substring(1) === current) {
          link.classList.add('active');
        }
      });
    };
    window.addEventListener('scroll', highlightSection);

    const handleAnchorClick = (e) => {
      if (e.target.tagName === 'A' && e.target.getAttribute('href')?.startsWith('#') && e.target.getAttribute('href') !== '#!') {
        e.preventDefault();
        const targetId = e.target.getAttribute('href');
        if (targetId !== '#') {
          const target = document.querySelector(targetId);
          if (target) {
            const offsetTop = target.getBoundingClientRect().top + window.pageYOffset - navbar.offsetHeight;
            window.scrollTo({ top: offsetTop, behavior: 'smooth' });
          }
        }
      }
    };
    document.querySelectorAll('a[href^="#"]').forEach(anchor =>
      anchor.addEventListener('click', handleAnchorClick)
    );

    const revealSections = () => {
      const windowHeight = window.innerHeight;
      const revealPoint = 150;
      sections.forEach(section => {
        const sectionTop = section.getBoundingClientRect().top;
        if (sectionTop < windowHeight - revealPoint) {
          section.classList.add('active');
        }
      });
    };
    window.addEventListener('scroll', revealSections);
    revealSections();

    return () => {
      hamburger.removeEventListener('click', toggleMenu);
      window.removeEventListener('scroll', handleNavbarScroll);
      window.removeEventListener('scroll', highlightSection);
      window.removeEventListener('scroll', revealSections);
      document.querySelectorAll('a[href^="#"]').forEach(anchor =>
        anchor.removeEventListener('click', handleAnchorClick)
      );
    };
  }, []);

  return (
    <>
      <header>
        <nav className="navbar d-flex align-items-center justify-content-between" ref={navbarRef}>
          <div className="hamburger ms-2">
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>

          <div className="logo">
            <Link to="/"><img className='header-logo' src={logo} alt="logo" /></Link>
          </div>

          <div className="d-flex align-items-center">
            <ul className="nav-menu d-flex align-items-center mb-0">
              <li className="nav-item"><Link to="/login?page=sales-enq-list" className={`nav-link ${location.pathname === '/sales-enq-list' || location.search.includes('sales-enq-list') ? 'active' : ''}`}>
                <span>Lead</span></Link></li>
              <li className="nav-item">
                <Link to="/login?page=customer"
                  className={`nav-link ${location.pathname === '/customer' || location.search.includes('customer') ? 'active' : ''}`}
                >
                  <span>Assign</span>
                </Link>
              </li>
              <li className="nav-item"><Link to="/login?page=estimation" className={`nav-link ${location.pathname === '/estimation' || location.search.includes('estimation') ? 'active' : ''}`}>
                <span>Estimation</span></Link></li>
              <li className="nav-item"><Link to="/login?page=sales-order" className={`nav-link ${location.pathname === '/sales-order' || location.search.includes('sales-order') ? 'active' : ''}`}>
                <span>Sales</span></Link></li>
              <li className="nav-item"><Link to="/login?page=management" className={`nav-link ${location.pathname === '/management' || location.search.includes('management') ? 'active' : ''}`}>
                <span>Report</span></Link></li>
              <li className="nav-item"><Link to="#!" onClick={handleLogout} className="nav-link">
                <span>Exit</span></Link></li>
              <a
                href="https://docs.google.com/spreadsheets/d/1Zl6RpUo9Dc7H1-ISiENucQUjxx8Hrtvl17dL2IKdUko/edit"
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: "flex", alignItems: "center" }}
              >
                <RiFileExcel2Fill
                  style={{
                    width: "25px",
                    height: "25px",
                    color: "white",
                    cursor: "pointer"
                  }}
                  title="Open Excel Report"
                />
              </a>
            </ul>
          </div>
        </nav>
      </header>
    </>
  );
}

export default Header;
